import { motion } from 'framer-motion'
import { Eye } from 'lucide-react'
import { Product_ } from 'src/api/db/apiProductsClosed'
import { AddToOrderButton } from 'src/shared/components/AddToOrderButton'
import { Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui'
import { useLocalization } from 'src/shared/hooks/useLocalization'

const HoverOverlay = () => (
  <div className="absolute inset-0 bg-gradient-to-t from-white via-white/75 to-transparent" />
)

export const ProductInfo = ({
  setOpen,
  isHovered,
  product,
  product_variant_color_id,
  isChat = false,
  showAddToQuote = true,
  showPreviewButton: showPreviewButtonProp,
  addToCurrentQuoteId,
  inOrderQuoteItemId,
}: {
  setOpen: (open: boolean) => void
  isHovered: boolean
  product?: Product_
  product_variant_color_id?: number
  isChat?: boolean
  showAddToQuote?: boolean
  showPreviewButton?: boolean
  addToCurrentQuoteId?: number
  inOrderQuoteItemId?: number
}) => {
  const { t } = useLocalization()

  if (!product?.id) {
    return null
  }

  const isMobile = window.innerWidth < 640
  const showPreviewButton =
    (showPreviewButtonProp ?? !isChat) && !isMobile
  const showActions = showPreviewButton || showAddToQuote

  if (!showActions) return null

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-0 overflow-hidden">
      {(isHovered || isMobile) && <HoverOverlay />}

      <div
        className={
          showActions
            ? 'relative z-10 p-2.5 pointer-events-auto'
            : 'relative z-10 p-2.5'
        }
      >
        <motion.div
          initial={{ opacity: isMobile ? 1 : 0, height: isMobile ? 'auto' : 0 }}
          animate={{
            opacity: isHovered || isMobile ? 1 : 0,
            height: isHovered || isMobile ? 'auto' : 0,
          }}
          transition={{
            duration: isMobile ? 0 : 0.1,
            ease: 'easeOut',
          }}
          className="overflow-hidden"
        >
          <Row className="gap-2">
            <div onClick={(e) => e.stopPropagation()} className="w-full">
              {showPreviewButton && (
                <Button
                  variant="secondary"
                  size="sm"
                  className="w-full mb-2"
                  onClick={() => {
                    setOpen(true)
                  }}
                >
                  <Eye className="w-3.5 h-3.5 mr-1.5" />
                  {t('Open preview', 'Öppna förhandsvisning')}
                </Button>
              )}

              {showAddToQuote && (
                <AddToOrderButton
                  product_id={product.id}
                  product_variant_color_id={product_variant_color_id}
                  unit_price={product.price!}
                  addToCurrentQuoteId={addToCurrentQuoteId}
                  inOrderQuoteItemId={inOrderQuoteItemId}
                  description={product.item_name!}
                />
              )}
            </div>
          </Row>
        </motion.div>
      </div>
    </div>
  )
}
